/* maydan-protections-iphone-default-manual-sort-start */
(function maydanProtectionsIphoneDefaultManualSort() {
  if (window.__maydanProtectionsIphoneDefaultManualSort) return;
  window.__maydanProtectionsIphoneDefaultManualSort = true;
  if (window.location.pathname !== '/collections/world-cup-2026-protections-iphone') return;
  var url = new URL(window.location.href);
  if (url.searchParams.has('sort_by')) return;
  url.searchParams.set('sort_by', 'manual');
  window.location.replace(url.toString());
})();
/* maydan-protections-iphone-default-manual-sort-end */

class Collection {
  constructor() {
    this.selectors = {
      section: ".facest-filters-section",
      toolbar: ".m-collection-toolbar",
      cols: [".m-toolbar--column-switcher button"],
      productContainer: "[data-product-container]",
      loadMoreBtn: "[data-load-more]",
      // Sidebar filters selectors
      sidebar: ".m-sidebar",
      sidebarContent: ".m-sidebar--content",
      openSidebar: ".m-sidebar--open",
      closeSidebar: ".m-sidebar--close",
      filtersWrapper: ".m-filter--wrapper",
    };
    this.mobileSortingSelectors = {
      openSorting: ".m-sortby--open",
      closeSorting: ".m-sortby-mobile--close",
      sortingWrapper: ".m-sortby-mobile--wrapper",
      sortingList: ".m-sortby-mobile--content",
    };
    this.sectionId = "";
    this.isDesignMode = MinimogSettings.design_mode;

    this.currentPage = 1;
    this.paginationType; // "paginate" | "loadmore" | "infinite"
    this.totalPages;
    this.totalProducts;
    this.infiniteLoadingObserver;

    this.showColSwitchers;
    this.cachedCol;
    this.initialCol;
    this.activeCol;
    this.STORAGE_KEY = "gridColumnViews";
    this.MAX_COL_BY_SCREEN_SIZE = {
      mobile: 2,
      tablet: 4,
      desktop: 5,
    };

    this.enableFilters;
    this.enableSorting;
    this.filtersType; // "storefront_filters" | "tags_filter"
    this.filtersPosition; // "leftColumn" | "rightColumn" | "fixed"
    this.accordions;
    this.sideEffectEventsAdded = false;
  }

  init = () => {
    this.domNodes = queryDomNodes(this.selectors);
    this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors);
    this.setData();
    this.initGridView();
    this.initFilters();
    this.initMobileSorting();
    this.initProducts();
    this.sideEffectEventsAdded = true;
    MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", () => refreshProductReview());

    // Handle sticky toolbar on mobile
    this.handleStickyToolbar();
    document.addEventListener("matchMobile", () => this.handleStickyToolbar());
    document.addEventListener("unmatchMobile", () => this.handleStickyToolbar());
  };

  setData = () => {
    const { section, productContainer } = this.domNodes;
    // Grid view data
    this.sectionId = section.dataset.sectionId;
    this.paginationType = section.dataset.paginationType;
    this.totalPages = productContainer && Number(productContainer.dataset.totalPages);
    this.view = section.dataset.view;
    // TODO: get from URL Search Params
    this.activeCol = null;
    this.currentPage = 1;
    this.initialCol = Number(section.dataset.initialColumn);
    this.cachedCol = Number(window.localStorage.getItem(this.getGridStorageKey())) || this.initialCol;
    if (this.getDeviceByScreenSize && this.getDeviceByScreenSize() === "desktop" && this.cachedCol < 3) this.cachedCol = this.initialCol;
    this.showColSwitchers = section.dataset.showColSwitchers === "true";
    // Filters data
    this.enableFilters = section.dataset.enableFilters === "true";
    this.enableSorting = section.dataset.enableSorting === "true";
    this.filtersType = section.dataset.filtersType;
    this.filtersPosition = section.dataset.filtersPosition;
  };

  initGridView = () => {
    this.toggleView(this.isDesignMode ? this.initialCol : this.cachedCol);
    this.updateViewByScreen();
    addEventDelegate({
      selector: this.selectors.cols[0],
      context: this.domNodes.toolbar,
      handler: (e, colNode) => this.toggleView(Number(colNode.dataset.column)),
    });
    this.initLoadMore();
    if (!this.sideEffectEventsAdded) {
      window.addEventListener("resize", debounce(this.updateViewByScreen, 500));
    }
  };

  initFilters = () => {
    if (!this.enableFilters) return;
    const { sidebar, openSidebar, closeSidebar } = this.domNodes;
    window.requestAnimationFrame(this.initAccordions);
    openSidebar.addEventListener("click", this.openSidebarFilter);
    closeSidebar.addEventListener("click", this.closeSidebarFilter);
    sidebar.addEventListener("click", (e) => e.target === sidebar && this.closeSidebarFilter());
  };

  initMobileSorting = () => {
    if (!this.enableSorting) return;
    const { openSorting, closeSorting, sortingWrapper } = this.mbSortingNodes;
    openSorting.addEventListener("click", this.openMobileSorting);
    closeSorting.addEventListener("click", this.closeMobileSorting);
    sortingWrapper.addEventListener("click", (e) => e.target === sortingWrapper && this.closeMobileSorting());
  };

  openMobileSorting = () => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes;
    sortingWrapper.style.display = "block";
    window.requestAnimationFrame(() => {
      sortingWrapper.style.setProperty("--m-bg-opacity", "0.5");
      sortingList.style.setProperty("--m-translate-y", "0");
    });
  };

  closeMobileSorting = (e) => {
    const { sortingWrapper, sortingList } = this.mbSortingNodes;
    sortingWrapper.style.setProperty("--m-bg-opacity", "0");
    sortingList.style.setProperty("--m-translate-y", "100%");
    setTimeout(() => sortingWrapper.style.setProperty("display", "none"), 300);
  };

  initAccordions = () => {
    this.accordions && this.accordions.destroy();
    const { filtersWrapper } = this.domNodes;
    filtersWrapper.classList.remove("acc-initialized");
    this.accordions = new MinimogLibs.Accordion(filtersWrapper, {
      presetContentHeight: false,
      callback: () => filtersWrapper.style.setProperty('opacity', '1')
    });
  };

  openSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;
    sidebar.style.display = "block";
    window.requestAnimationFrame(() => {
      sidebar.style.setProperty("--m-bg-opacity", "0.5");
      sidebarContent.style.setProperty("--m-translate-x", "0");
      this.accordions && this.accordions.setContentHeight();
    });
    section.classList.add("sidebar-open");
  };

  closeSidebarFilter = () => {
    const { sidebar, sidebarContent, section } = this.domNodes;
    section.classList.remove("sidebar-open");
    if (window.innerWidth < 1280 || sidebar.dataset.type === "fixed") {
      sidebarContent.style.setProperty("--m-translate-x", "-100%");
      sidebar.style.removeProperty("--m-bg-opacity");
      setTimeout(() => sidebar.style.removeProperty("display"), 300);
    }
  };

  getGridStorageKey = () => {
    return `${this.STORAGE_KEY}:${this.getDeviceByScreenSize()}`;
  };

  toggleView = (col, options = {}) => {
    if (!col || this.view === "search") return;
    const { cols, productContainer } = this.domNodes;
    if (!productContainer) return;
    const persist = options.persist !== false;
    // Resize image product card
    const allImages = productContainer.querySelectorAll("responsive-image");
    if (allImages && allImages.length > 0) {
      allImages.forEach((img) => {
        img.disconnectedCallback();
        img.connectedCallback();
      });
    }

    const activeCol = this.activeCol || this.initialCol;
    if (this.showColSwitchers) {
      cols[activeCol - 1]?.classList?.remove("active");
      cols[col - 1]?.classList?.add("active");
    }

    productContainer.classList.remove(`m-cols-${activeCol}`);
    productContainer.classList.add(`m-cols-${col}`);

    if (persist) window.localStorage.setItem(this.getGridStorageKey(), col);
    this.activeCol = col;
  };

  updateViewByScreen = () => {
    if (this.activeCol === 1) return; // List layout
    const device = this.getDeviceByScreenSize();
    const maxCol = this.MAX_COL_BY_SCREEN_SIZE[device];
    if (maxCol < this.activeCol) this.toggleView(maxCol, { persist: false });
  };

  getDeviceByScreenSize = () => {
    if (window.innerWidth < 768) return "mobile";
    if (window.innerWidth < 1024) return "tablet";
    return "desktop";
  };

  initLoadMore = () => {
    if (this.paginationType === "paginate" || this.totalPages <= 1 || this.view === "search") return;

    const { loadMoreBtn } = this.domNodes;
    loadMoreBtn.addEventListener("click", this.loadMoreProducts);

    if (this.paginationType === "infinite") {
      this.infiniteLoadingObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio === 1) this.loadMoreProducts();
          });
        },
        { threshold: 1 }
      );

      this.infiniteLoadingObserver.observe(loadMoreBtn);
    }
  };

  loadMoreProducts = () => {
    const nextPage = this.currentPage + 1;
    if (nextPage > this.totalPages) return;

    const { productContainer, loadMoreBtn } = this.domNodes;
    this.toggleLoading(true);
    fetchSection(this.sectionId, { fromCache: true, params: { page: nextPage } })
      .then((productGridHTML) => {
        const productNodes = productGridHTML.querySelectorAll("[data-product-container] .m-product-item");
        productNodes.forEach((prodNode) => productContainer.appendChild(prodNode));
        this.initProducts();
      })
      .catch((err) => console.error(`Failed to load more products.`, err))
      .finally(() => {
        MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED");
        this.toggleLoading(false);
        this.currentPage = nextPage;
        if (nextPage >= this.totalPages) {
          loadMoreBtn.parentNode.remove();
          this.infiniteLoadingObserver && this.infiniteLoadingObserver.unobserve(loadMoreBtn);
        }
      });
  };

  initProducts = () => {
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
  };

  toggleLoading = (loading) => {
    const { loadMoreBtn } = this.domNodes;
    if (loadMoreBtn) {
      const method = loading ? "add" : "remove";
      loadMoreBtn.classList[method]("m-spinner-loading");
    }
  };

  handleStickyToolbar() {
    const toolbar = this.domNodes.toolbar;
    const extraSpace = toolbar && toolbar.offsetTop;
    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      if (MinimogTheme.config.mqlMobile) {
        const currentScroll = window.scrollY;
        if (currentScroll <= extraSpace) {
          toolbar.classList.remove("scroll-up", "m-collection-toolbar--sticky");
          return;
        }
        toolbar.classList.add("m-collection-toolbar--sticky");
        if (
          currentScroll > toolbar.offsetHeight + extraSpace &&
          currentScroll > lastScroll &&
          !toolbar.classList.contains("scroll-down")
        ) {
          toolbar.classList.remove("scroll-up");
          toolbar.classList.add("scroll-down");
        } else if (currentScroll < lastScroll && toolbar.classList.contains("scroll-down")) {
          toolbar.classList.remove("scroll-down");
          toolbar.classList.add("scroll-up");
        }
        lastScroll = currentScroll;
      } else {
        toolbar.classList.remove("scroll-up", "m-collection-toolbar--sticky", "scroll-down");
      }
    });
  }
}

(function () {
  const TARGET_COLLECTION_PATHS = new Set([
    "/collections/bureaux-chaises",
    "/collections/consoles-gaming",
    "/collections/ecouteurs",
    "/collections/accesscare",
    "/collections/montres-connectees",
  ]);

  function normalizeSamsungVendorFacet() {
    const path = window.location.pathname.replace(/\/$/, "");
    if (path !== "/collections/samsung") return;

    const inputs = Array.from(document.querySelectorAll('input[name="filter.p.vendor"]')).filter(
      (input) => String(input.value || "").toLowerCase() === "samsung"
    );
    const hasUppercaseValue = inputs.some((input) => input.value === "SAMSUNG");

    inputs.forEach((input) => {
      const item = input.closest(".m-facet--item");
      const label = item?.querySelector(".m-facet--label");
      if (label) label.textContent = "SAMSUNG";
      if (hasUppercaseValue && input.value !== "SAMSUNG" && item) item.style.display = "none";
    });

    document.querySelectorAll(".m-active-facets__button, .m-filter--tag").forEach((node) => {
      if (node.textContent && node.textContent.trim().toLowerCase() === "samsung") {
        node.textContent = "SAMSUNG";
      }
    });
  }

  function ensureMaydanInStockStyles() {
    if (document.getElementById("maydan-instock-pagination-styles")) return;

    const style = document.createElement("style");
    style.id = "maydan-instock-pagination-styles";
    style.textContent = `
      #CollectionProductGrid .m-product-item:has(.m-product-card--soldout) {
        display: none !important;
      }
      .maydan-instock-pagination {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
        margin-top: 32px;
      }
      .maydan-instock-pagination__button {
        align-items: center;
        background: #fff;
        border: 1px solid #d9dde8;
        border-radius: 999px;
        color: #183c7a;
        cursor: pointer;
        display: inline-flex;
        font: inherit;
        height: 38px;
        justify-content: center;
        min-width: 38px;
        padding: 0 14px;
      }
      .maydan-instock-pagination__button:hover,
      .maydan-instock-pagination__button[aria-current="page"] {
        background: #1f5594;
        border-color: #1f5594;
        color: #fff;
      }
      .maydan-instock-pagination__button:disabled {
        cursor: not-allowed;
        opacity: 0.45;
      }
    `;
    document.head.appendChild(style);
  }

  function initMaydanInStockPagination(container) {
    const productContainer = container.querySelector('[data-product-container][data-maydan-client-pagination="true"]');
    const pagination = container.querySelector("[data-maydan-instock-pagination]");

    if (!productContainer || !pagination) return;

    const items = Array.from(productContainer.querySelectorAll(".m-product-item")).filter((item) => {
      return !item.querySelector(".m-product-card--soldout");
    });
    const pageSize = Number(productContainer.dataset.maydanPageSize || 16);
    const totalPages = Math.ceil(items.length / pageSize);

    if (!Number.isFinite(pageSize) || pageSize < 1 || totalPages <= 1) {
      pagination.innerHTML = "";
      items.forEach((item) => {
        item.style.display = "";
      });
      return;
    }

    let currentPage = 1;

    function setPage(nextPage) {
      currentPage = Math.max(1, Math.min(totalPages, nextPage));
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;

      items.forEach((item, index) => {
        item.style.display = index >= start && index < end ? "" : "none";
      });

      const buttons = [];
      buttons.push(
        `<button type="button" class="maydan-instock-pagination__button" data-maydan-page="${currentPage - 1}" ${
          currentPage === 1 ? "disabled" : ""
        }>Precedent</button>`
      );

      for (let page = 1; page <= totalPages; page += 1) {
        buttons.push(
          `<button type="button" class="maydan-instock-pagination__button" data-maydan-page="${page}" ${
            page === currentPage ? 'aria-current="page"' : ""
          }>${page}</button>`
        );
      }

      buttons.push(
        `<button type="button" class="maydan-instock-pagination__button" data-maydan-page="${currentPage + 1}" ${
          currentPage === totalPages ? "disabled" : ""
        }>Suivant</button>`
      );

      pagination.innerHTML = buttons.join("");
    }

    pagination._maydanSetPage = setPage;

    if (pagination.dataset.maydanBound !== "true") {
      pagination.dataset.maydanBound = "true";
      pagination.addEventListener("click", (event) => {
        const button = event.target.closest("[data-maydan-page]");
        if (!button || button.disabled) return;
        const pageHandler = pagination._maydanSetPage;
        if (typeof pageHandler === "function") {
          pageHandler(Number(button.dataset.maydanPage));
        }
        container.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    setPage(1);
  }

  function getVisibleProductStats(container) {
    const grid = container.querySelector("[data-product-container]");
    if (!grid) return { items: 0, soldout: false, paginated: false };

    return {
      items: grid.querySelectorAll(".m-product-item").length,
      soldout: Boolean(grid.querySelector(".m-product-card--soldout")),
      paginated: Boolean(grid.matches('[data-maydan-client-pagination="true"]')),
    };
  }

  async function refreshMaydanCachedCollection() {
    normalizeSamsungVendorFacet();

    const path = window.location.pathname.replace(/\/$/, "");
    if (!TARGET_COLLECTION_PATHS.has(path)) return;

    const currentGrid = document.querySelector("#CollectionProductGrid");
    if (!currentGrid) return;

    ensureMaydanInStockStyles();

    const currentStats = getVisibleProductStats(currentGrid);
    if (currentStats.paginated && !currentStats.soldout) {
      initMaydanInStockPagination(currentGrid);
      return;
    }

    const refreshUrl = new URL(window.location.href);
    if (!refreshUrl.searchParams.has("sort_by")) {
      refreshUrl.searchParams.set("sort_by", "best-selling");
    }
    refreshUrl.searchParams.set("maydan_js_refresh", Date.now().toString());

    try {
      const response = await fetch(refreshUrl.toString(), {
        cache: "no-store",
        credentials: "same-origin",
      });
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const freshGrid = doc.querySelector("#CollectionProductGrid");

      if (!freshGrid) return;

      const freshStats = getVisibleProductStats(freshGrid);
      if (!freshStats.paginated || freshStats.soldout) return;

      currentGrid.replaceWith(freshGrid);
      initMaydanInStockPagination(freshGrid);
      if (window.MinimogTheme && MinimogTheme.CompareProduct) MinimogTheme.CompareProduct.setCompareButtonsState();
      if (window.MinimogTheme && MinimogTheme.Wishlist) MinimogTheme.Wishlist.setWishlistButtonsState();
      if (typeof refreshProductReview === "function") refreshProductReview();
    } catch (error) {
      console.warn("Maydan collection refresh skipped.", error);
    }
  }

  function initMaydanCollectionAfterAjaxRender() {
    normalizeSamsungVendorFacet();

    const path = window.location.pathname.replace(/\/$/, "");
    if (!TARGET_COLLECTION_PATHS.has(path)) return;

    ensureMaydanInStockStyles();
    window.requestAnimationFrame(() => {
      document.querySelectorAll("#CollectionProductGrid").forEach(initMaydanInStockPagination);
    });
  }

  let maydanCollectionObserverStarted = false;

  function startMaydanCollectionObserver() {
    if (maydanCollectionObserverStarted || typeof MutationObserver === "undefined" || !document.body) return;
    maydanCollectionObserverStarted = true;

    let queued = false;
    const scheduleRefresh = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        initMaydanCollectionAfterAjaxRender();
      });
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!node || node.nodeType !== 1) continue;
          if (
            node.id === "CollectionProductGrid" ||
            node.matches?.("[data-product-container], [data-maydan-instock-pagination]") ||
            node.querySelector?.("#CollectionProductGrid, [data-product-container], [data-maydan-instock-pagination]")
          ) {
            scheduleRefresh();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      normalizeSamsungVendorFacet();
      refreshMaydanCachedCollection();
      startMaydanCollectionObserver();
    });
  } else {
    normalizeSamsungVendorFacet();
    refreshMaydanCachedCollection();
    startMaydanCollectionObserver();
  }
  document.addEventListener("collection:rerendered", initMaydanCollectionAfterAjaxRender);
  document.addEventListener("shopify:section:load", initMaydanCollectionAfterAjaxRender);
})();

/* maydan-wc2026-pack-offre-cards-fallback-start */
(function maydanPackOffreWorldCupCards() {
  var cards = [
    { title: "Packs World Cup 2026", url: "/collections/world-cup-2026-packs", count: "22 produits" },
    { title: "Power Banks", url: "/collections/world-cup-2026-power-banks", count: "13 produits" },
    { title: "Protections iPhone", url: "/collections/world-cup-2026-protections-iphone", count: "13 produits" },
    { title: "Audio", url: "/collections/world-cup-2026-audio", count: "9 produits" },
    { title: "Chargeurs & Câbles", url: "/collections/world-cup-2026-chargeurs-cables", count: "8 produits" },
    { title: "Accessoires Voyage & Camping", url: "/collections/world-cup-2026-accessoires-voyage-camping", count: "13 produits" }
  ];

  function createCardsSection() {
    if (!/^\/collections\/pack-offre\/?$/.test(window.location.pathname)) return;
    if (document.querySelector(".maydan-wc2026-cards")) return;

    var mainSection = document.querySelector("[data-section-type=\"featured-collection\"]");
    mainSection = mainSection ? mainSection.closest(".shopify-section") : null;
    if (!mainSection) {
      mainSection = document.querySelector(".facest-filters-section");
      mainSection = mainSection ? mainSection.closest(".shopify-section") : null;
    }
    if (!mainSection || !mainSection.parentNode) return;

    var section = document.createElement("section");
    section.className = "maydan-wc2026-cards maydan-wc2026-cards--js";
    section.setAttribute("aria-labelledby", "maydan-wc2026-cards-title");

    var links = cards.map(function(card, index) {
      return '<a class="maydan-wc2026-card" href="' + card.url + '">' +
        '<span class="maydan-wc2026-card__media" aria-hidden="true"><span class="maydan-wc2026-card__icon-slot"></span></span>' +
        '<span class="maydan-wc2026-card__body"><strong>' + card.title + '</strong><small>' + card.count + '</small></span>' +
        '<span class="maydan-wc2026-card__arrow" aria-hidden="true"></span>' +
      '</a>';
    }).join("");

    section.innerHTML = '<div class="container">' +
      '<div class="maydan-wc2026-cards__header">' +
        '<h2 id="maydan-wc2026-cards-title">Offres World Cup 2026</h2>' +
        '<p>Accédez directement aux offres par besoin.</p>' +
      '</div>' +
      '<div class="maydan-wc2026-cards__grid">' + links + '</div>' +
    '</div>';

    var style = document.createElement("style");
    style.textContent = ".maydan-wc2026-cards{--maydan-wc-blue:#004f9a;--maydan-wc-green:#0b8f65;--maydan-wc-red:#da3f3f;--maydan-wc-ink:#142033;--maydan-wc-muted:#667085;--maydan-wc-border:#d9e2ee;margin:0;padding:22px 0 28px;background:#fff}.maydan-wc2026-cards__header{display:flex;align-items:flex-end;justify-content:space-between;gap:18px;margin-bottom:14px}.maydan-wc2026-cards__header h2{margin:0;color:var(--maydan-wc-ink);font-size:24px;font-weight:800;line-height:1.2;letter-spacing:0}.maydan-wc2026-cards__header p{max-width:520px;margin:0;color:var(--maydan-wc-muted);font-size:14px;font-weight:500;line-height:1.45;text-align:right}.maydan-wc2026-cards__grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px}.maydan-wc2026-card{display:grid;grid-template-columns:42px minmax(0,1fr) 18px;align-items:center;gap:10px;min-height:78px;padding:12px;border:1px solid var(--maydan-wc-border);border-radius:8px;background:#fff;box-shadow:0 6px 18px rgba(20,32,51,.06);color:var(--maydan-wc-ink);text-decoration:none;transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease}.maydan-wc2026-card:hover{border-color:rgba(0,79,154,.42);box-shadow:0 12px 26px rgba(20,32,51,.11);transform:translateY(-1px);color:var(--maydan-wc-ink)}.maydan-wc2026-card__media{display:grid;place-items:center;width:42px;height:42px;border-radius:8px;background:#f2f7fd;overflow:hidden}.maydan-wc2026-card:nth-child(2n) .maydan-wc2026-card__media{background:#f0faf6}.maydan-wc2026-card:nth-child(3n) .maydan-wc2026-card__media{background:#fff4f4}.maydan-wc2026-card__icon-slot{display:block;width:18px;height:18px;border:2px solid var(--maydan-wc-blue);border-radius:6px;position:relative}.maydan-wc2026-card:nth-child(2n) .maydan-wc2026-card__icon-slot{border-color:var(--maydan-wc-green)}.maydan-wc2026-card:nth-child(3n) .maydan-wc2026-card__icon-slot{border-color:var(--maydan-wc-red)}.maydan-wc2026-card__icon-slot:after{content:\"\";position:absolute;right:-5px;bottom:-5px;width:8px;height:8px;border-radius:50%;background:currentColor;color:inherit}.maydan-wc2026-card__body{min-width:0}.maydan-wc2026-card__body strong{display:block;color:var(--maydan-wc-ink);font-size:13px;font-weight:800;line-height:1.22;letter-spacing:0}.maydan-wc2026-card__body small{display:block;margin-top:4px;color:var(--maydan-wc-muted);font-size:11px;font-weight:700;line-height:1.1}.maydan-wc2026-card__arrow{width:9px;height:9px;border-top:2px solid var(--maydan-wc-blue);border-right:2px solid var(--maydan-wc-blue);transform:rotate(45deg);justify-self:end}@media screen and (max-width:1199px){.maydan-wc2026-cards__grid{grid-template-columns:repeat(3,minmax(0,1fr))}}@media screen and (max-width:767px){.maydan-wc2026-cards{padding:16px 0 22px}.maydan-wc2026-cards__header{display:block;margin-bottom:12px}.maydan-wc2026-cards__header h2{font-size:19px}.maydan-wc2026-cards__header p{margin-top:5px;max-width:none;font-size:12px;text-align:left}.maydan-wc2026-cards__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}.maydan-wc2026-card{grid-template-columns:34px minmax(0,1fr);min-height:74px;gap:8px;padding:10px}.maydan-wc2026-card__media{width:34px;height:34px}.maydan-wc2026-card__body strong{font-size:12px}.maydan-wc2026-card__body small{font-size:10px}.maydan-wc2026-card__arrow{display:none}}";
    document.head.appendChild(style);
    mainSection.parentNode.insertBefore(section, mainSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createCardsSection);
  } else {
    createCardsSection();
  }
})();
/* maydan-wc2026-pack-offre-cards-fallback-end */

/* maydan-pack-offre-sort-handler-start */
(function maydanPackOffreAjaxSortHandler() {
  if (window.__maydanPackOffreSortHandlerInstalled) return;
  window.__maydanPackOffreSortHandlerInstalled = true;

  function isPackOffre() {
    return /^\/collections\/pack-offre\/?$/.test(window.location.pathname);
  }

  function pageUrlForSort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('_maydan_ajax_sort_v');
    return url;
  }

  function replaceFromHtml(html, value, pageUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextGrid = doc.querySelector('#CollectionProductGrid');
    var currentGrid = document.querySelector('#CollectionProductGrid');
    if (!nextGrid || !currentGrid) return false;

    currentGrid.replaceWith(nextGrid);

    var nextSortMobile = doc.querySelector('.m-sortby-mobile');
    var currentSortMobile = document.querySelector('.m-sortby-mobile');
    if (nextSortMobile && currentSortMobile) currentSortMobile.replaceWith(nextSortMobile);

    var label = document.querySelector('[data-sortby-option]');
    var option = document.querySelector('.m-select-custom--option[data-value="' + CSS.escape(value) + '"]');
    if (label && option) label.textContent = option.textContent.trim();

    window.history.replaceState({}, '', pageUrl.toString());
    document.dispatchEvent(new CustomEvent('collection:rerendered'));
    document.dispatchEvent(new CustomEvent('maydan:pack-offre-sort', { detail: { sortBy: value } }));
    return true;
  }

  function applySort(value) {
    if (!isPackOffre() || !value) return;
    var pageUrl = pageUrlForSort(value);
    var fetchUrl = new URL(pageUrl.href);
    fetchUrl.searchParams.set('_maydan_ajax_sort_v', '20260627134000-' + Date.now());

    document.documentElement.classList.add('maydan-pack-offre-sorting');
    fetch(fetchUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('sort fetch failed');
        return response.text();
      })
      .then(function(html) {
        if (!replaceFromHtml(html, value, pageUrl)) {
          window.location.href = pageUrl.toString();
        }
      })
      .catch(function() {
        window.location.href = pageUrl.toString();
      })
      .finally(function() {
        document.documentElement.classList.remove('maydan-pack-offre-sorting');
      });
  }

  document.addEventListener('change', function(event) {
    if (!isPackOffre()) return;
    var select = event.target && event.target.closest && event.target.closest('.m-toolbar--sortby select[name="sort_by"], select[name="sort_by"].js-selectNative');
    if (!select) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applySort(select.value);
  }, true);

  document.addEventListener('click', function(event) {
    if (!isPackOffre()) return;
    var option = event.target && event.target.closest && event.target.closest('.m-select-custom--option[data-value], .m-sortby-mobile--item[data-value]');
    if (!option) return;
    var value = option.getAttribute('data-value');
    if (!value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applySort(value);
  }, true);
})();
/* maydan-pack-offre-sort-handler-end */

/* maydan-pack-offre-exact-icon-bg-js-20260613:start */
(function() {
  if (window.location.pathname !== '/collections/pack-offre') return;
  var css = [
    '.maydan-wc2026-card__media { border: 0 !important; background: url(//www.maydan.ma/cdn/shop/t/6/assets/maydan-wc2026-card-background-empty.jpg?v=65061381387326988051781352740) center center / cover no-repeat !important; box-shadow: none !important; }',
    '.maydan-wc2026-card__media::before, .maydan-wc2026-card__media::after { content: none !important; display: none !important; background: none !important; }',
    '.maydan-wc2026-card__icon-badge { background: transparent !important; box-shadow: none !important; }',
    '.maydan-wc2026-card__icon-png { background: transparent !important; }'
  ].join('\n');
  function injectExactIconBackground() {
    if (document.getElementById('maydan-pack-offre-exact-icon-bg')) return;
    var style = document.createElement('style');
    style.id = 'maydan-pack-offre-exact-icon-bg';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectExactIconBackground, { once: true });
  } else {
    injectExactIconBackground();
  }
})();
/* maydan-pack-offre-exact-icon-bg-js-20260613:end */

/* Maydan filter accordion click fix start */
(function() {
  var VERSION = 2;
  if ((window.__maydanFilterAccordionClickFixVersion || 0) >= VERSION) return;
  window.__maydanFilterAccordionClickFixVersion = VERSION;
  window.__maydanFilterAccordionClickFix = true;

  function getForm(node) {
    return node && node.closest && node.closest("#CollectionFiltersForm");
  }

  function getWidget(node) {
    return node && node.closest && node.closest(".m-filter--widget");
  }

  function getContent(widget) {
    if (!widget) return null;
    return widget.querySelector(":scope > .m-filter--widget-content, :scope > .m-accordion--item-content") ||
      widget.querySelector(".m-filter--widget-content, .m-accordion--item-content");
  }

  function getTitle(widget) {
    if (!widget) return null;
    return widget.querySelector(":scope > .m-filter--widget-title, :scope > .m-accordion--item-button") ||
      widget.querySelector(".m-filter--widget-title, .m-accordion--item-button");
  }

  function isOpen(widget) {
    var title = getTitle(widget);
    return !!(widget && (widget.classList.contains("open") || (title && title.getAttribute("aria-expanded") === "true")));
  }

  function ensureStyles() {
    if (document.getElementById("MaydanFilterAccordionFixStyles")) return;
    var style = document.createElement("style");
    style.id = "MaydanFilterAccordionFixStyles";
    style.textContent = [
      "#CollectionFiltersForm .m-filter--widget-content,#CollectionFiltersForm .m-accordion--item-content{transition:none!important;animation:none!important;}",
      "#CollectionFiltersForm .m-filter--widget-title,#CollectionFiltersForm .m-accordion--item-button{cursor:pointer;}",
      "body:has(.maydan-monitor-filters) .facest-filters-section .m-sidebar{scrollbar-color:#e8edf3 transparent;scrollbar-width:thin;}",
      "body:has(.maydan-monitor-filters) .facest-filters-section .m-sidebar::-webkit-scrollbar{width:4px;}",
      "body:has(.maydan-monitor-filters) .facest-filters-section .m-sidebar::-webkit-scrollbar-track{background:transparent;}",
      "body:has(.maydan-monitor-filters) .facest-filters-section .m-sidebar::-webkit-scrollbar-thumb{background:#e8edf3;border-radius:999px;}",
      "@media(max-width:767px){body:has(.maydan-monitor-filters) .m-sidebar .m-sidebar--content{max-height:100dvh!important;overflow-y:auto!important;padding-bottom:104px!important;width:min(92vw,390px)!important;-webkit-overflow-scrolling:touch!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form>.m-filter--widget{margin:0!important;padding:22px 0!important;border-top:1px solid #edf0f2!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form>.m-filter--widget[data-maydan-monitor-group='price']{border-top:0!important;padding-top:0!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form .m-filter--widget-title{align-items:center!important;display:flex!important;justify-content:space-between!important;margin:0!important;min-height:32px!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form .m-filter--widget-content{margin-top:14px!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form .m-filter--scroll-content{max-height:none!important;overflow:visible!important;padding-right:0!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form .m-facet--item{margin:0 0 12px!important;min-height:34px!important;}body:has(.maydan-monitor-filters) #CollectionFiltersForm.maydan-monitor-filter-form .m-facet--checkbox{align-items:center!important;display:flex!important;gap:12px!important;line-height:1.25!important;min-height:34px!important;}}"
    ].join("\n");
    (document.head || document.documentElement).appendChild(style);
  }

  function setWidgetState(widget, open) {
    if (!widget) return;
    var content = getContent(widget);
    var title = getTitle(widget);
    widget.classList.toggle("open", !!open);
    if (title) {
      title.setAttribute("aria-expanded", open ? "true" : "false");
      title.setAttribute("role", "button");
      if (!title.hasAttribute("tabindex")) title.setAttribute("tabindex", "0");
    }
    if (!content) return;
    content.style.setProperty("transition", "none", "important");
    content.style.setProperty("animation", "none", "important");
    if (open) {
      content.style.setProperty("display", "block", "important");
      content.style.setProperty("height", "auto", "important");
      content.style.setProperty("max-height", "none", "important");
      content.style.setProperty("opacity", "1", "important");
      content.style.setProperty("overflow", "visible", "important");
      content.style.setProperty("pointer-events", "auto", "important");
    } else {
      content.style.setProperty("display", "none", "important");
      content.style.setProperty("height", "0", "important");
      content.style.setProperty("max-height", "0px", "important");
      content.style.setProperty("opacity", "0", "important");
      content.style.setProperty("overflow", "hidden", "important");
      content.style.setProperty("pointer-events", "none", "important");
    }
  }

  function normalizeForm(form) {
    if (!form) return;
    form.querySelectorAll(".m-filter--widget").forEach(function(widget) {
      if (!getContent(widget)) return;
      setWidgetState(widget, isOpen(widget));
    });
  }

  var scheduled = false;
  function refreshAll() {
    scheduled = false;
    ensureStyles();
    document.querySelectorAll("#CollectionFiltersForm").forEach(normalizeForm);
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refreshAll);
  }

  function toggleFromTitle(title, event) {
    var form = getForm(title);
    var widget = getWidget(title);
    if (!form || !widget) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    setWidgetState(widget, !isOpen(widget));
  }

  document.addEventListener("click", function(event) {
    var title = event.target && event.target.closest && event.target.closest("#CollectionFiltersForm .m-filter--widget-title, #CollectionFiltersForm .m-accordion--item-button");
    if (!title) return;
    toggleFromTitle(title, event);
  }, true);

  document.addEventListener("keydown", function(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var title = event.target && event.target.closest && event.target.closest("#CollectionFiltersForm .m-filter--widget-title, #CollectionFiltersForm .m-accordion--item-button");
    if (!title) return;
    toggleFromTitle(title, event);
  }, true);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var target = mutations[i].target;
        if (target && target.closest && (target.closest("#CollectionFiltersForm") || target.closest(".facest-filters-section"))) {
          scheduleRefresh();
          return;
        }
      }
    });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener("DOMContentLoaded", function() {
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }

  window.MaydanFilterAccordionFix = { refresh: scheduleRefresh, setWidgetState: setWidgetState };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refreshAll);
  else refreshAll();
  document.addEventListener("collection:rerendered", scheduleRefresh);
  document.addEventListener("shopify:section:load", scheduleRefresh);
})();
/* Maydan filter accordion click fix end */

/* Maydan pc-portables 16pp runtime refresh start */
(function() {
  if (window.__maydanPcPortables16ppRuntimeRefresh) return;
  window.__maydanPcPortables16ppRuntimeRefresh = true;
  function isTargetCollection() {
    return window.location.pathname.replace(/\/+$/, "") === "/collections/pc-portables";
  }
  function itemCount(node) {
    return node ? node.querySelectorAll(".m-product-item").length : 0;
  }
  function sectionId() {
    var section = document.querySelector(".facest-filters-section[data-section-id]");
    return section && section.getAttribute("data-section-id");
  }
  function totalPages(node) {
    var list = node && node.querySelector("[data-total-pages]");
    return list ? parseInt(list.getAttribute("data-total-pages") || "0", 10) : 0;
  }
  function freshSectionUrl(id) {
    var url = new URL(window.location.href);
    url.searchParams.set("section_id", id);
    url.searchParams.set("maydan_16pp_runtime", String(Date.now()));
    return url.toString();
  }
  function refreshGridIfNeeded() {
    if (!isTargetCollection() || !window.fetch || !window.DOMParser) return;
    var grid = document.getElementById("CollectionProductGrid");
    if (!grid || grid.getAttribute("data-maydan-16pp-refreshed") === "1") return;
    var currentCount = itemCount(grid);
    if (currentCount >= 16) return;
    var id = sectionId();
    if (!id) return;
    grid.setAttribute("data-maydan-16pp-refreshed", "1");
    fetch(freshSectionUrl(id), { credentials: "same-origin", cache: "no-store" })
      .then(function(response) { return response.ok ? response.text() : ""; })
      .then(function(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var freshGrid = doc.getElementById("CollectionProductGrid");
        if (!freshGrid) return;
        var freshCount = itemCount(freshGrid);
        if (freshCount < 16 && freshCount <= currentCount) return;
        if (totalPages(freshGrid) >= totalPages(grid) && freshCount <= currentCount) return;
        grid.replaceWith(document.importNode(freshGrid, true));
        document.dispatchEvent(new CustomEvent("collection:rerendered", { bubbles: true }));
      })
      .catch(function() {
        grid.removeAttribute("data-maydan-16pp-refreshed");
      });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshGridIfNeeded, { once: true });
  } else {
    setTimeout(refreshGridIfNeeded, 0);
  }
  setTimeout(refreshGridIfNeeded, 1200);
})();
/* Maydan pc-portables 16pp runtime refresh end */
